import React from 'react'
import PropTypes from 'prop-types'

const LoginButton = (props) => (
	<button className="LoginButton" onClick={props.click}><span>{props.text}</span></button>
)

LoginButton.propTypes = {
	click: PropTypes.func,
	text: PropTypes.string.isRequired
}

export default LoginButton


// WEBPACK FOOTER //
// ./src/components/UserLoginControl/LoginButton.js